import { WAC_CROSSFLOW_PARAMS } from '@townsquare/crossflow/wac';
import { farewellFeedResource } from '@townsquare/discover-view/farewell-feed-resource';
import { loomFeedResource } from '@townsquare/discover-view/loom-feed-resource';
import { popularFeedResource } from '@townsquare/discover-view/popular-feed-resource';
import { welcomeFeedResource } from '@townsquare/discover-view/welcome-feed-resource';
import { homeHeaderViewResource } from '@townsquare/home-header/resources';
import Loadable from '@townsquare/loadable';
import { onboardingResource } from '@townsquare/onboarding/resource';
import { homeTabRoute as homeTabRouteDefinition } from '@townsquare/routes/hometab-view';
import { titanEapCrossFlowQueryResource } from '@townsquare/titan-eap-cross-flow/resource';
import { workFeedSectionResource, assignedSectionResource } from '@townsquare/work-feeds';

homeTabRouteDefinition.component = Loadable({
  loader: () => import(/* webpackChunkName: "hometab-view" */ './components/HomeTabView'),
  loading: () => null,
});
homeTabRouteDefinition.resources = [
  titanEapCrossFlowQueryResource,
  homeHeaderViewResource,
  workFeedSectionResource,
  assignedSectionResource,
  onboardingResource,
  popularFeedResource,
  welcomeFeedResource,
  farewellFeedResource,
  loomFeedResource,
];
homeTabRouteDefinition.query = [...WAC_CROSSFLOW_PARAMS.map(param => `${param}?`), 'src?', 'cloudId?'];
export const homeTabRoute = homeTabRouteDefinition;
